/**
 * The one place the deploy watcher throws the page away. The navigation reload, the resume reload
 * and the banner button all end here, so "who may reload the app" stays greppable.
 */
export function applyUpdate(): void {
  window.location.reload();
}
